<template>
  <SettingsRow class="h-auto! min-h-[70px] py-[24px]">
    <template #left>
      <div class="whitespace-nowrap mr-4">Email</div>
    </template>

    <template #right>
      <div class="flex">
        <template v-if="user">
          <div class="mr-4 text-right [word-break:break-word] max-w-[720px]">
            {{ user?.email }}
          </div>
          <div
            class="text-[14px] text-link"
            @click="emit('openDialog', 'ChangeEmail')"
          >
            Edit
          </div>
        </template>
        <template v-else>
          <Skeleton class="w-[160px] h-[18px] mr-4" />
          <Skeleton class="w-[30px] h-[18px]" />
        </template>
      </div>
    </template>
  </SettingsRow>

  <SettingsRow class="h-auto! min-h-[70px] py-[24px]">
    <template #left>
      <div class="whitespace-nowrap mr-4">Username</div>
    </template>

    <template #right>
      <div class="flex">
        <template v-if="user">
          <div class="mr-4 text-right [word-break:break-word] max-w-[720px]">
            {{ user?.username }}
          </div>
          <div
            class="text-[14px] text-link"
            @click="emit('openDialog', 'ChangeUsername')"
          >
            Edit
          </div>
        </template>
        <template v-else>
          <Skeleton class="w-[80px] h-[18px] mr-4" />
          <Skeleton class="w-[30px] h-[18px]" />
        </template>
      </div>
    </template>
  </SettingsRow>

  <SettingsRow class="h-auto! min-h-[70px] py-[24px]">
    <template #left>
      <div class="whitespace-nowrap mr-4">Title</div>
    </template>

    <template #right>
      <div class="flex">
        <template v-if="user">
          <div class="mr-4 text-right [word-break:break-word] max-w-[720px]">
            {{ user?.title }}
          </div>
          <div
            class="text-[14px] text-link"
            @click="emit('openDialog', 'ChangeTitle')"
          >
            {{ user?.title ? 'Edit' : 'Add' }}
          </div>
        </template>
        <template v-else>
          <Skeleton class="w-[50px] h-[18px] mr-4" />
          <Skeleton class="w-[30px] h-[18px]" />
        </template>
      </div>
    </template>
  </SettingsRow>

  <SettingsRow class="h-auto! min-h-[70px] py-[24px] mb-11">
    <template #left>
      <div class="whitespace-nowrap mr-4">Bio</div>
    </template>

    <template #right>
      <div class="flex">
        <template v-if="user">
          <div
            class="mr-4 [word-break:break-word] max-w-[285px] tablet-v:max-w-[720px]"
          >
            {{ user?.bio }}
          </div>
          <div
            class="text-[14px] text-link"
            @click="emit('openDialog', 'ChangeBio')"
          >
            {{ user?.bio ? 'Edit' : 'Add' }}
          </div>
        </template>
        <template v-else>
          <Skeleton class="w-[200px] h-[18px] mr-4" />
          <Skeleton class="w-[30px] h-[18px]" />
        </template>
      </div>
    </template>
  </SettingsRow>
</template>

<script setup lang="ts">
import SettingsRow from '@/features/settings/components/SettingsRow.vue'
import { Skeleton } from '@dacr/library'
import type { UserFieldsFragment } from '@/shared/graphql/legacy/generated'

defineProps<{
  user: UserFieldsFragment | null
}>()

const emit = defineEmits<{
  (e: 'openDialog', name: string): void
}>()
</script>
